import React from 'react';
import { DataGrid,useGridSlotComponentProps ,trTR } from "@mui/x-data-grid";
import { createTheme,ThemeProvider } from '@mui/material/styles';
import { makeStyles } from '@material-ui/styles';
import Pagination from '@mui/lab/Pagination';
import PaginationItem from '@mui/lab/PaginationItem';
function EtcDataGrid(props) {

    function customCheckbox(theme) {
        return {
            '& .MuiCheckbox-root svg': {
                width: 16,
                height: 16,
                backgroundColor: 'transparent',
                border: '1px solid rgb(189,189,189)',
                borderRadius: 4,
            },
            '& .MuiCheckbox-root svg path': {
                display: 'none',
            },
            '& .MuiCheckbox-root.Mui-checked svg': {
                backgroundColor: '#79b7f9',
                borderColor: '#1890ff',
            },
            '& .MuiCheckbox-root.Mui-checked .MuiIconButton-label:after': {
                position: 'absolute',
                display: 'table',
                border: '2px solid #fff',
                borderTop: 0,
                borderLeft: 0,
                transform: 'rotate(45deg) translate(-50%,-50%)',
                opacity: 1,
                transition: 'all .2s cubic-bezier(.12,.4,.29,1.46) .1s',
                content: '""',
                top: '50%',
                left: '39%',
                width: 5.71428571,
                height: 9.14285714,
            }
        };
    }

    function CustomPagination() {
        const { state, apiRef } = useGridSlotComponentProps();
        return (
            <div style={{display:'inline-flex',width:'100%',paddingBottom:'4px'}}>
                <div style={{alignSelf:'center' , justifyContent: 'center',width:'100%',display: 'flex'}}>
                    {(state.pagination.pageCount && state.pagination.pageCount > 0) ? <Pagination
                        size="small"
                        color="primary"
                        page={state.pagination.page ? state.pagination.page : 1 }
                        count={state.pagination.pageCount > 1 ? state.pagination.pageCount - 1 : 1 }
                        renderItem={(props2) => <PaginationItem size="small" {...props2} />}
                        onChange={(event, value) => apiRef.current.setPage(value)}
                    /> : ""}
                </div>
            </div>

        );
    }


    const defaultTheme = createTheme(
        {
            palette: {
                primary: { main: '#1976d2' },
            },
        },
        trTR,
    );

    const useStyles = makeStyles(
        (theme) => ({
            root: {
                color: 'rgba(255,255,255,0.85)',
                fontFamily: [
                    '-apple-system',
                    'BlinkMacSystemFont',
                    '"Segoe UI"',
                    'Roboto',
                    '"Helvetica Neue"',
                    'Arial',
                    'sans-serif',
                    '"Apple Color Emoji"',
                    '"Segoe UI Emoji"',
                    '"Segoe UI Symbol"',
                ].join(','),
                WebkitFontSmoothing: 'auto',
                letterSpacing: 'normal',
                '& .MuiDataGrid-columnsContainer': {
                    backgroundColor: '#fafafa',
                },
                '& .MuiDataGrid-columnHeaderCheckbox': {
                    display: 'block',
                },
                '& .MuiDataGrid-iconSeparator': {
                    display: 'none',
                },
                '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
                    border: '1px solid rgb(222, 226, 230)',
                },
                '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {
                    borderBottom: '1px solid #f0f0f0'
                },
                '& .MuiDataGrid-cell': {
                    color:'rgba(0,0,0,.85)',
                },
                '& .MuiPaginationItem-root': {
                    border: '1px solid rgb(222, 226, 230)',
                },
                '& .MuiPaginationItem-sizeSmall': {
                    height: '14px',
                    fontSize: '12px',
                    color:'rgba(0,0,0,.85)',
                    borderRadius: '13px'
                },
                '& .MuiDataGrid-row:nth-child(odd)': {
                    color: '#212529',
                    backgroundColor: 'rgba(0,0,0,.075)'
                },
                ...customCheckbox(theme),
            },
        }),
        { defaultTheme },
    );


    const classes = useStyles();
    return (<ThemeProvider theme={defaultTheme}>
        <DataGrid localeText={trTR.props.MuiDataGrid.localeText} rows={props.data} columns={props.columns} pageSize={props.pageSize}
                  sortModel={props.sortModel}
                  checkboxSelection
                  disableSelectionOnClick
                  disableExtendRowFullWidth={true}
                  headerHeight={35}
                  className={classes.root}
                  onRowDoubleClick={(param) => {
                      if(props.onRowDoubleClick){
                          props.onRowDoubleClick(param)
                      }
                  }}
                  isCellEditable={false}
                  hideFooterSelectedRowCount={false}
                  rowHeight={35}
                  selectionModel={props.selectionModel}
                  onSelectionModelChange={props.onSelectionModelChange}
                  components={{
                      Footer: CustomPagination
                  }}
        />
    </ThemeProvider>)

}

export default EtcDataGrid;